import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { LoadingStatus } from 'interfaces/loading-statuses';
import { RootState } from 'state/store';
import { tenantApi } from './api';

export enum FeatureFlag {
    Phase1Payers = 'Phase 1 Payers',
}

type IFeatureFlagsState = {
    loadingActiveFeatureFlags: LoadingStatus;
    activeFeatureFlags?: FeatureFlag[];
};

const initialState: IFeatureFlagsState = {
    loadingActiveFeatureFlags: LoadingStatus.Idle,
};

const featureFlags = createSlice({
    name: 'featureFlags',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getActiveFeatureFlagsForTenant.pending, (state) => {
                state.loadingActiveFeatureFlags = LoadingStatus.Pending;
            })
            .addCase(getActiveFeatureFlagsForTenant.fulfilled, (state, { payload }) => {
                state.loadingActiveFeatureFlags = LoadingStatus.Completed;
                state.activeFeatureFlags = payload;
            })
            .addCase(getActiveFeatureFlagsForTenant.rejected, (state) => {
                state.loadingActiveFeatureFlags = LoadingStatus.Failed;
            });
    },
});

const { reducer } = featureFlags;

export default reducer;

//Async Actions
export const getActiveFeatureFlagsForTenant = createAsyncThunk<FeatureFlag[], { tenantId: string }, { rejectValue: string }>(
    'getActiveFeatureFlagsForTenant',
    async ({ tenantId }, { rejectWithValue }) => {
        try {
            const response = await tenantApi.getFeatureFlagsForTenant(tenantId);
            return response.data;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message);
            }
            return rejectWithValue(e as string);
        }
    },
);

//Selectors
export const selectFeatureFlagsState = (state: RootState) => state.tenant.featureFlags;
export const selectActiveFeatureFlags = createSelector(selectFeatureFlagsState, (state) =>
    (state.activeFeatureFlags ?? []).map((flag) => flag.trim()),
);
export const selectActiveFeatureFlagsLookup = createSelector(selectActiveFeatureFlags, (featureFlags) => {
    return new Set<string>(featureFlags);
});
export const selectActiveFeatureFlagsLoading = createSelector(
    selectFeatureFlagsState,
    (state) => state.loadingActiveFeatureFlags,
);
